type CssFile =
  // Base
  | 'globals.css'
  | 'globals-no-normalize.css'
  | 'tests.css'
  // Extensions
  | 'extensions/components.css'
  | 'extensions/print.css'
  | 'extensions/cloak.css'
  | 'extensions/grid.css'
  | 'extensions/spacing.css'
  | 'extensions/typography.css'
  // Debuggers
  | 'debuggers/grid.css'
  | 'debuggers/media-query.css';

/**
 * @name getCssUrl
 *
 * @description Get the URL of a CSS file, relative to the current file. To be used with importmaps.
 *
 * @example
 * import { getCssUrl } from '@workbench/core';
 *
 * const url = getCssUrl('globals.css');
 * // url = 'https://assets.oneweb.mercedes-benz.com/plugin/workbench/core/7.40.1/css/globals.css'
 */
export function getCssUrl(cssFile: CssFile) {
  return new URL(`../css/${cssFile}`, import.meta.url).href;
}
